import type {Metadata, WorkV4} from '../types';

export const replaceWork = (work: WorkV4, metadata: Metadata): Metadata => {
  return {...metadata, work};
};
